/**
 * Mirrors packages/amgfootball_v2/lib/core/constants/api_constants.dart
 * + game_constants.dart for endpoints, game keys, and the reference resolution
 * used by the Flutter web build.
 */
export const API_BASE = 'https://staginggameapi.tbgcablecar.xyz/api';

export const Endpoints = {
  login: `${API_BASE}/action/login`,
  openGame: `${API_BASE}/action/opengame`,
  checkBalance: `${API_BASE}/action/balance`,
  getInfo: `${API_BASE}/action/getinfo`,
  placeBet: `${API_BASE}/action/bet`,
  getHistory: `${API_BASE}/action/bethistory`,
} as const;

/** Single-player game key (api_constants.dart: gameKey = 'SSC1'). */
export const GAME_KEY_SINGLE = 'SSC1';
/** Multiplayer game key (api_constants.dart: multiplayerGameKey = 'SSCM'). */
export const GAME_KEY_MULTI = 'SSCM';
/** Goal-shooting multiplayer hub (api_constants.dart: multiplayerHubUrl). */
export const MULTIPLAYER_HUB_URL =
  'https://staginggameapi.tbgcablecar.xyz/goalshootinghub';
export const DEFAULT_AGENT_ID = 'Agent1';

/** Reference stage size — mirrors apps/amg_football_v2/web/index.html */
export const REF_WIDTH = 1792;
export const REF_HEIGHT = 828;

/**
 * Hard-coded test credentials — match the Flutter `LobbyScreen` /
 * `main.dart` `/Index` route defaults (userName 'user5', agentId 'Agent1').
 * The lobby logs in with these and password `123456`, then calls openGame.
 */
export const DEFAULT_USER_NAME = 'user5';
export const DEFAULT_PASSWORD = '123456';

/**
 * Default game config — used until /action/getinfo overrides.
 * Mirrors GameConfig defaults in game_constants.dart
 * (minBet 10, maxBet 10000, chips [1,5,10,25,50,100]).
 */
export const DEFAULT_GAME_CONFIG = {
  minBet: 10,
  maxBet: 10000,
  chipValues: [1, 5, 10, 25, 50, 100] as const,
};

/** Default odds per goal (2.00 each — game_constants.dart GameConfig.odds). */
export const DEFAULT_ODDS = ['2.00', '2.00', '2.00'] as const;

/**
 * Multiplayer bet-countdown offset (seconds) subtracted from the server's
 * StartTime→EndTime window. Mirrors GameConstants.betCountdownOffset = 2.
 */
export const MP_BET_COUNTDOWN_OFFSET_S = 2;
